export default "__VITE_ASSET__6iePl7af__"